import { gql, useLazyQuery } from '@apollo/client'

export interface BackgroundTaskResult {
  downloadUrl?: string
  fileName?: string
  stats?: {
    totalProducts?: number
    exported?: number
    errors?: number
  }
  message?: string
}

export interface BackgroundTaskItem {
  id: number
  type: string
  status: string
  result?: BackgroundTaskResult | null
  error_log?: unknown
  created_at?: string | null
  completed_at?: string | null
}

export interface AllBackgroundTasksResponse {
  allBackgroundTasks: {
    items: BackgroundTaskItem[]
    total: number
    page: number
    pageSize: number
    totalPages: number
  }
}

export interface BackgroundTaskFilterInput {
  status?: string
  type?: string
  from_date?: string
  to_date?: string
}

export interface AllBackgroundTasksVariables {
  filter?: BackgroundTaskFilterInput
  page?: number
  pageSize?: number
}

export const GQL_QUERY_ALL_BACKGROUND_TASKS = gql`
  query AllBackgroundTasks(
    $filter: BackgroundTaskFilterInput
    $page: Int
    $pageSize: Int
  ) {
    allBackgroundTasks(filter: $filter, page: $page, pageSize: $pageSize) {
      total
      page
      pageSize
      totalPages
      items {
        id
        type
        status
        result
        error_log
        created_at
        completed_at
      }
    }
  }
`

export const useLazyQueryBackgroundTasks = (variables?: AllBackgroundTasksVariables) => {
  return useLazyQuery<AllBackgroundTasksResponse, AllBackgroundTasksVariables>(
    GQL_QUERY_ALL_BACKGROUND_TASKS,
    {
      variables,
      fetchPolicy: 'network-only',
    }
  )
}
